// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { injectCss } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { baseClassName } from "@werner/App/Components/XngExpirationDatePicker/utils/constants";
import { CommonInputProps } from "@werner/App/Components/XngExpirationDatePicker/utils/types";
import React, { ForwardRefRenderFunction } from "react";
import styled from "styled-components";

type NativeInputProps = CommonInputProps & InjectableCss;

const StyledInput = styled.input<NativeInputProps>`
    width: ${({ width }) => width || 25}px;
    ${injectCss}
`;

const NativeInput: ForwardRefRenderFunction<unknown, NativeInputProps> = ({
    ariaLabel,
    className,
    placeholder = "--",
    value,
    onFocus,
    inputRef: ref,
    ...otherProps
}) => {
    const inputRef = React.useRef<HTMLInputElement>(null);

    React.useImperativeHandle(ref, () => ({
        focus: () => {
            inputRef.current?.focus();
        },
        blur: () => {
            inputRef.current?.blur();
        },
    }));

    const handleFocus: React.FocusEventHandler<HTMLInputElement> = event => {
        const { target } = event;
        target.select();
        onFocus?.(event);
    };

    return (
        <StyledInput
            key="input"
            aria-label={ariaLabel}
            autoComplete="off"
            className={`${baseClassName}__inputGroup__input ${className || ""}`}
            inputMode="numeric"
            onFocus={handleFocus}
            placeholder={placeholder}
            type="number"
            step="1"
            value={value !== null ? value : ""}
            ref={inputRef}
            {...otherProps}
        />
    );
};

export default React.forwardRef(NativeInput);
